import React, { useEffect, useState } from 'react'

import { BeefyButton } from '@enkla-gui'
import PropTypes from 'prop-types'

export default function CheckBox({ controls, name, options, label, preChangeHook }) {
  const { setValue, getValues, register, watch } = controls

  const toBoolean = (value) => value === true || value === 'true' || value === 1 || value === '1'

  const [isChecked, setIsChecked] = useState(toBoolean(getValues(name)))
  const externalValue = typeof watch === 'function' ? watch(name) : undefined
  useEffect(() => {
    if (typeof externalValue !== 'undefined') {
      setIsChecked(toBoolean(externalValue))
    }
  }, [externalValue])
  useEffect(() => {
    setValue(name, isChecked)
  }, [isChecked, name, setValue])
  return (
    <div className='component_CheckBox'>
      <input {...register(name, options)} type='hidden' value={isChecked} />
      <BeefyButton
        _default={{
          text: label,
          icon: isChecked ? 'fa fa-check' : 'fa fa-times'
        }}
        hover={{
          text: label,
          icon: !isChecked ? 'fa fa-check' : 'fa fa-times'
        }}
        type={!isChecked ? 'info' : 'success'}
        callback={async () => {
          const nextValue = !isChecked
          if (typeof preChangeHook === 'function') {
            try {
              const result = preChangeHook(isChecked, nextValue)
              const shouldProceed = await Promise.resolve(result)
              if (shouldProceed === false) return
            } catch (e) {
              return
            }
          }
          setIsChecked(nextValue)
        }}
      />
    </div>
  )
}

CheckBox.propTypes = {
  controls: PropTypes.shape({
    setValue: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    watch: PropTypes.func
  }).isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.object,
  label: PropTypes.string,
  preChangeHook: PropTypes.func
}

CheckBox.defaultProps = {
  options: undefined,
  label: undefined,
  preChangeHook: undefined
}
